import { Component, OnInit } from '@angular/core';
import { TransportAssocService } from 'app/services/transport-assoc.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { AlertComponent } from 'app/popup/alert.component';
import { ErrorComponent } from 'app/popup/error.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-transport-association-list',
  templateUrl: './transport-association-list.component.html',
  styleUrls: ['./transport-association-list.component.css']
})
export class TransportAssociationListComponent implements OnInit {
  transports: any = [];
  isRemove = false;
  removeRef: any;
  criteria = 'code';
  direction = false;
  page = 1;
  lblHeading = '';

  popoverTitle = 'Delete Transport Association';
  popoverMessage = 'Are you sure you want to delete Transport Association?';
  confirmText = 'Yes <i class="glyphicon glyphicon-ok"></i>';
  cancelText = 'No <i class="glyphicon glyphicon-remove"></i>';
  confirmClicked = false;
  cancelClicked = false;
  deleteConfirm = '';
  message = "Loading Transport Association...";
  showNum: number = 10;

  public isLoading = false;
  isEmpty: boolean = false;

  constructor(private service: TransportAssocService,
     private utility: UtilityServiceService,private toastr:ToastrService) { }

  ngOnInit() {
    this.onChangeHeandig();
    this.reload();
  }

  reload() {
    this.isLoading = true;
    this.service.getAll().subscribe(result => {
      this.transports = result;
      //console.log(this.transports);
      this.utility.onSort(5);
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      this.isEmpty = true;
    });
  }

  onDelete(id: any) {
    this.service.delete(id).subscribe(result => {

      // this.dialogService.addDialog(AlertComponent, { title: 'Delete Transport Association', message: `Transport Association ${this.removeRef.code} deleted.`, bold: `${this.removeRef.code}` });
      this.toastr.success(`Transport Association ${this.removeRef.code} deleted.`,'Delete Transport Association');
      if (result != null) {
        this.onNo();
        this.reload();
      }
      this.onChangeHeandig();
    }, error => {
      error = error.json();
      // this.dialogService.addDialog(ErrorComponent, { title: 'Delete Transport Association', message: `Transport Association ${this.removeRef.code} was not deleted.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
      this.toastr.success(`Transport Association ${this.removeRef.code} was not deleted.`,'Delete Transport Association');
    });
  }

  onSort() {
    this.direction = !this.direction;
  }

  onConfirm(doc: any) {
    this.removeRef = doc;
    this.deleteConfirm = `Are you sure you want to delete Transport Association <strong>${this.removeRef.code}</strong>?`;
    this.onChangeHeandig(false);
    this.isRemove = true;
  }

  onNo() {
    this.isRemove = false;
    this.onChangeHeandig();
  }

  onChangeHeandig(change: boolean = true) {
    this.lblHeading = (change) ? 'Transport Associations' : 'Delete Transport Association';
  }



}
